import { ListSubheader, ListSubheaderProps } from '@mui/material'
import React from 'react'

export type WcListSubheaderProps = ListSubheaderProps

export const WcListSubheader = ({children, ...props}: WcListSubheaderProps) => (
    <ListSubheader {...props}>{children}</ListSubheader>
  )
